import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EmailStateService {
  private emailSubject = new BehaviorSubject<string>('');
  public email$: Observable<string> = this.emailSubject.asObservable();

  private showBannerSubject = new BehaviorSubject<boolean>(false);
  public showBanner$: Observable<boolean> = this.showBannerSubject.asObservable();

  setEmail(email: string): void {
    this.emailSubject.next(email || '');
  }

  getEmail(): string {
    return this.emailSubject.getValue();
  }

  setShowBanner(show: boolean): void {
    this.showBannerSubject.next(!!show);
  }

  getShowBanner(): boolean {
    return this.showBannerSubject.getValue();
  }
}
